<template>
  <generic-modal
    :title="$t('financial record')"
    ref="generic_modal"
    :is_wide="true"
  >
    <form v-if="meta && meta.settings">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("top left code") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.settings.top_left_code"
                placeholder="3-67-GG"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("folio") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.settings.folio"
                placeholder="1060"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("financial record number") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.settings.record_number"
                placeholder="FMVA GG-051-2024"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("record date") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.settings.record_date"
                placeholder="25 de marzo de 2025"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("record hour") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.settings.record_hour"
                placeholder="10:00 horas"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t("celebration date") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.settings.celebration_date"
            placeholder="veinticuatro de junio del año dos mil veinticuatro, a las quince horas"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("celebration place") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.settings.celebration_place"
            placeholder="Financiera MVA, S.A."
          />
        </div>
      </div>
      <div class="field">
        <label class="label">{{
          $t("assistant list (comma separated)")
        }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.settings.assistant_list"
            placeholder="Juan Pérez, María González, Pedro Ramírez"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("presenter analyst") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.settings.presenter_analyst"
            placeholder="La señora Raquel Noemi Rodríguez Veliz, Analista de créditos"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("excel file") }}</label>
        <div class="control">
          <input class="input" type="file" @change="on_file_change" />
        </div>
      </div>
      <!-- <pre>{{ meta }}</pre> -->
      <table
        class="table is-fullwidth"
        v-if="meta.case_list && meta.case_list.length"
      >
        <thead>
          <tr>
            <th>{{ $t("promissory note number") }}</th>
            <th>Monto línea</th>
            <th>Saldo de crédito</th>
            <th>Saldo a factorar</th>
            <th>{{ $t("discount") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(itm, idx) in meta.case_list" :key="idx">
            <td>{{ itm[0] }}</td>
            <td>{{ format_currency(itm[1]) }}</td>
            <td>{{ format_currency(itm[2]) }}</td>
            <td>{{ format_currency(itm[3]) }}</td>
            <td>{{ format_currency(itm[4]) }}</td>
          </tr>
        </tbody>
      </table>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-bolt"></i>
        </span>
        <span>{{ $t("generate") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  format_currency,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import readXlsxFile from "read-excel-file";

export default {
  name: "RecordModal",
  components: { GenericModal },
  props: {
    module_settings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      post("/financial-record/record", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      if (v.module_settings) {
        if (v.module_settings.folio)
          v.meta.settings.folio = v.module_settings.folio;
        if (v.module_settings.top_left_code)
          v.meta.settings.top_left_code = v.module_settings.top_left_code;
        if (v.module_settings.record_number)
          v.meta.settings.record_number = v.module_settings.record_number;
        if (v.module_settings.celebration_date)
          v.meta.settings.celebration_date = v.module_settings.celebration_date;
        if (v.module_settings.celebration_place)
          v.meta.settings.celebration_place =
            v.module_settings.celebration_place;
        if (v.module_settings.assistant_list)
          v.meta.settings.assistant_list = v.module_settings.assistant_list;
        if (v.module_settings.presenter_analyst)
          v.meta.settings.presenter_analyst =
            v.module_settings.presenter_analyst;
      }
      v.error = "";
    },
    on_file_change(e) {
      let v = this;
      let file = e.target.files[0];
      readXlsxFile(file).then((rows) => {
        let first_row = rows.find((r) => r);
        if (first_row) {
          // let headers = first_row.map((h) => h.toLowerCase());
          let data = rows.slice(1);
          v.meta.case_list = data;
        }
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
